import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/newhome/footer/youtube.webp")